import React, { useEffect } from 'react';
import moment from 'moment';
import { Parser } from 'html-to-react';
import { AvatarBlurb } from '../../AvatarBlurb';
import { IconBlurb } from '../../IconBlurb';
import { getDateDifference, getLocalTime, pluralize } from '../../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWSessionInfo = function TWSessionInfo(_ref) {
  var _providerService$prov, _providerService$prov2, _providerService$prov3, _providerService$prov4;

  var session = _ref.session,
      existingBooking = _ref.existingBooking,
      currentUser = _ref.currentUser,
      _ref$renderHeading = _ref.renderHeading,
      renderHeading = _ref$renderHeading === void 0 ? true : _ref$renderHeading,
      _ref$renderProvider = _ref.renderProvider,
      renderProvider = _ref$renderProvider === void 0 ? true : _ref$renderProvider,
      _ref$renderDetails = _ref.renderDetails,
      renderDetails = _ref$renderDetails === void 0 ? true : _ref$renderDetails,
      getUserSessionBookings = _ref.getUserSessionBookings;
  var parser = new Parser();
  useEffect(function () {
    if (currentUser) getUserSessionBookings(session.id);
  }, [session.id, currentUser]);
  var providerService = session.providerService,
      capacity = session.capacity,
      attendeeNotes = session.attendeeNotes;
  var personPluralized = pluralize('person', 'people', capacity || 0);
  var capacityDescription = capacity ? "Up to ".concat(capacity, " ").concat(personPluralized) : 'Unlimited attendees';

  var _getLocalTime = getLocalTime(moment(session.startsAt)),
      localSessionStart = _getLocalTime.localTime;

  var sessionTime = "".concat(localSessionStart.format('dddd, MMMM DD'), " at ").concat(localSessionStart.format('h:mm A z'));
  var locationIconName = session.virtual ? 'laptop' : 'map';
  var locationIconDescription = session.virtual ? 'Online' : 'In-person';
  var bookingExists = existingBooking && existingBooking.status === 'active';

  var renderSessionDetails = function renderSessionDetails() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(IconBlurb, {
        title: "Date & Time",
        iconName: "calendar",
        iconType: "regular",
        description: sessionTime,
        titleClasses: "text-neutral-400",
        descriptionClasses: "text-neutral-500"
      }), /*#__PURE__*/_jsx(IconBlurb, {
        title: "Duration",
        iconName: "stopwatch",
        iconType: "regular",
        description: getDateDifference(session === null || session === void 0 ? void 0 : session.startsAt, session === null || session === void 0 ? void 0 : session.endsAt, 'minutes'),
        titleClasses: "text-neutral-400",
        descriptionClasses: "text-neutral-500"
      }), /*#__PURE__*/_jsx(IconBlurb, {
        title: "Location",
        iconName: locationIconName,
        iconType: "regular",
        description: locationIconDescription,
        titleClasses: "text-neutral-400",
        descriptionClasses: "text-neutral-500"
      }), /*#__PURE__*/_jsx(IconBlurb, {
        iconName: "users",
        iconType: "regular",
        title: "Capacity",
        description: capacityDescription,
        titleClasses: "text-neutral-400",
        descriptionClasses: "text-neutral-500"
      }), attendeeNotes && bookingExists && /*#__PURE__*/_jsx(IconBlurb, {
        iconName: "sticky-note",
        iconType: "regular",
        title: "Attendee Notes",
        description: parser.parse(attendeeNotes),
        titleClasses: "text-neutral-400",
        descriptionClasses: "text-neutral-500"
      })]
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "block",
    children: [renderHeading && /*#__PURE__*/_jsxs("div", {
      className: "flex-col mb-7 hidden md:flex",
      children: [/*#__PURE__*/_jsx("span", {
        className: "text-2xl font-bold",
        children: session.name
      }), /*#__PURE__*/_jsx("span", {
        className: "text-lg text-neutral-500",
        children: sessionTime
      })]
    }), renderProvider && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "hidden md:block",
        children: /*#__PURE__*/_jsx(AvatarBlurb, {
          avatarUrl: providerService === null || providerService === void 0 ? void 0 : providerService.avatarUrl,
          title: providerService === null || providerService === void 0 ? void 0 : providerService.name,
          description: providerService === null || providerService === void 0 ? void 0 : (_providerService$prov = providerService.provider) === null || _providerService$prov === void 0 ? void 0 : _providerService$prov.name,
          titleURL: "/".concat(providerService === null || providerService === void 0 ? void 0 : (_providerService$prov2 = providerService.provider) === null || _providerService$prov2 === void 0 ? void 0 : _providerService$prov2.slug, "/").concat(providerService === null || providerService === void 0 ? void 0 : providerService.slug),
          descriptionUrl: "/".concat(providerService === null || providerService === void 0 ? void 0 : (_providerService$prov3 = providerService.provider) === null || _providerService$prov3 === void 0 ? void 0 : _providerService$prov3.slug)
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "block md:hidden",
        children: [/*#__PURE__*/_jsx("span", {
          className: "block text-2xl font-bold",
          children: session.name
        }), /*#__PURE__*/_jsxs("span", {
          className: "block text-lg text-neutral-500",
          children: [sessionTime, ", with ", providerService === null || providerService === void 0 ? void 0 : (_providerService$prov4 = providerService.provider) === null || _providerService$prov4 === void 0 ? void 0 : _providerService$prov4.name]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "text-base text-neutral-500 mt-6 break-long-words",
      children: parser.parse(session.description)
    }), renderDetails && renderSessionDetails()]
  });
};